$(document).ready(function () {
  let bkReviewsFilterDirty = false;

  // вернуть исходные значения
  function bkReviewsReturn() {
    // проверяем, был ли использован фильтр
    if (bkReviewsFilterDirty) {
      $.ajax({
        method: "POST",
        url: "ajax/bkreviewsreturn",
      }).done(function (resp) {
        $(".bk__reviews").html(resp);
      });

      $(".bk__reviews__filter__count").removeClass("active");
      $(".bk__reviews__filter__link__burger").addClass("active");
    }
  }

  // фильтр "звезды"
  $(".bk__reviews__filter__window__rating__star").click(function () {
    $(".bk__reviews__filter__window__rating__star").removeClass("active");
    $(this).addClass("active");
    $(this).prevAll().addClass("active");

    if (
      $(".bk__reviews__filter__window__checkox").is(":checked") ||
      $(".bk__reviews__filter__window__rating__star.active").length
    ) {
      $(".bk__reviews__filter__cancel").removeClass(
        "bk__reviews__filter__cancel--active"
      );
      $(".bk__reviews__filter__options").addClass(
        "bk__reviews__filter__options--active"
      );
    } else {
      $(".bk__reviews__filter__cancel").addClass(
        "bk__reviews__filter__cancel--active"
      );
      $(".bk__reviews__filter__options").removeClass(
        "bk__reviews__filter__options--active"
      );
    }
  });

  $(".bk__reviews__filter__window__rating__star").hover(function () {
    $(this).prevAll().toggleClass("active2");
  });

  $(".bk__reviews__filter__link").click(function (evt) {
    evt.preventDefault();

    $(".bk__reviews__filter__window").addClass(
      "bk__reviews__filter__window--active"
    );

    if ($(window).width() < 767) {
      $(".mask").addClass("mask--active");
      $("html").addClass("noscroll");
    }
  });

  // закрываем фильтр по клику вне
  $(document).mouseup(function (evt) {
    const bkReviewsFilterWindow = $(".bk__reviews__filter__window");
    if (
      !bkReviewsFilterWindow.is(evt.target) &&
      bkReviewsFilterWindow.has(evt.target).length === 0
    ) {
      bkReviewsFilterWindow.removeClass("bk__reviews__filter__window--active");
    }
  });

  // закрываем фильтр по кнопе
  $(".bk__reviews__filter__cancel").click((evt) => {
    evt.preventDefault();
    $(".bk__reviews__filter__window").removeClass(
      "bk__reviews__filter__window--active"
    );
    $(".mask").removeClass("mask--active");
    $("html").removeClass("noscroll");
  });

  // фильтр "бк"
  $(".bk__reviews__filter__window__checkox").click(function () {
    if (
      $(".bk__reviews__filter__window__checkox").is(":checked") ||
      $(".bk__reviews__filter__window__rating__star.active").length
    ) {
      $(".bk__reviews__filter__cancel").removeClass(
        "bk__reviews__filter__cancel--active"
      );
      $(".bk__reviews__filter__options").addClass(
        "bk__reviews__filter__options--active"
      );
    } else {
      $(".bk__reviews__filter__cancel").addClass(
        "bk__reviews__filter__cancel--active"
      );
      $(".bk__reviews__filter__options").removeClass(
        "bk__reviews__filter__options--active"
      );
      bkReviewsReturn();
    }
  });

  // очистить фильтр
  $("#bkReviewsFilterClear").click((evt) => {
    evt.preventDefault();
    $(".bk__reviews__filter__window__checkox").prop("checked", false);
    $(".bk__reviews__filter__window__rating__star").removeClass("active");
    $(".bk__reviews__filter__cancel").addClass(
      "bk__reviews__filter__cancel--active"
    );
    $(".bk__reviews__filter__options").removeClass(
      "bk__reviews__filter__options--active"
    );

    bkReviewsReturn();

    $(".bk__reviews__filter__window").removeClass(
      "bk__reviews__filter__window--active"
    );

    $(".mask").removeClass("mask--active");
    $("html").removeClass("noscroll");
  });

  // применить
  $("#bkReviewsFilterApply").click(function (evt) {
    evt.preventDefault();
    let bkThreads = [];

    $(".bk__reviews__filter__window__checkox:checked").each(function () {
      let bkThread = $(this).attr("id");
      bkThreads.push(bkThread);
    });

    let ratingValue = $(
      ".bk__reviews__filter__window__rating__star.active"
    ).length;

    $.ajax({
      method: "POST",
      url: "ajax/bkreviewsfilter",
      data: { thread: bkThreads.join(), rating: ratingValue },
    }).done(function (resp) {
      if (resp) {
        $(".bk__reviews").html(resp);
      } else {
        $(".bk__reviews").html(
          '<p class="forecast__response__text">Отзывы не найдены</p>'
        );
      }
    });

    bkReviewsFilterDirty = true;

    $(".bk__reviews__filter__window").removeClass(
      "bk__reviews__filter__window--active"
    );

    let filterCount = 0;

    filterCount += +$(".bk__reviews__filter__window__checkox:checked").length;

    if ($(".bk__reviews__filter__window__rating__star.active").length) {
      filterCount += 1;
    }

    $(".bk__reviews__filter__count").html(filterCount);
    $(".bk__reviews__filter__count").addClass("active");
    $(".bk__reviews__filter__link__burger").removeClass("active");

    $(".mask").removeClass("mask--active");
    $("html").removeClass("noscroll");
  });

  // применить
  $("#bkReviewsFilterApplySingle").click(function (evt) {
    evt.preventDefault();

    let ratingValue = $(
      ".bk__reviews__filter__window__rating__star.active"
    ).length;

    const thread = $(".bk__reviews__filter").data("bk-thread");

    $.ajax({
      method: "POST",
      url: "ajax/bkreviewsfilter",
      data: { thread: thread, rating: ratingValue },
    }).done(function (resp) {
      if (resp) {
        $(".bk__reviews").html(resp);
      } else {
        $(".bk__reviews").html(
          '<p class="forecast__response__text">Отзывы не найдены</p>'
        );
      }
    });

    bkReviewsFilterDirty = true;

    $(".bk__reviews__filter__window").removeClass(
      "bk__reviews__filter__window--active"
    );

    let filterCount = 0;

    if ($(".bk__reviews__filter__window__rating__star.active").length) {
      filterCount += 1;
    }

    $(".bk__reviews__filter__count").html(filterCount);
    $(".bk__reviews__filter__count").addClass("active");
    $(".bk__reviews__filter__link__burger").removeClass("active");

    $(".mask").removeClass("mask--active");
    $("html").removeClass("noscroll");
  });

  // очистить фильтр
  $("#bkReviewsFilterClearSingle").click((evt) => {
    evt.preventDefault();
    $(".bk__reviews__filter__window__checkox").prop("checked", false);
    $(".bk__reviews__filter__window__rating__star").removeClass("active");
    $(".bk__reviews__filter__cancel").addClass(
      "bk__reviews__filter__cancel--active"
    );
    $(".bk__reviews__filter__options").removeClass(
      "bk__reviews__filter__options--active"
    );

    let ratingValue = 0;

    const thread = $(".bk__reviews__filter").data("bk-thread");

    $.ajax({
      method: "POST",
      url: "ajax/bkreviewsfilter",
      data: { thread: thread, rating: ratingValue },
    }).done(function (resp) {
      if (resp) {
        $(".bk__reviews").html(resp);
      } else {
        $(".bk__reviews").html(
          '<p class="forecast__response__text">Отзывы не найдены</p>'
        );
      }
    });

    $(".bk__reviews__filter__count").removeClass("active");
    $(".bk__reviews__filter__link__burger").addClass("active");

    $(".bk__reviews__filter__window").removeClass(
      "bk__reviews__filter__window--active"
    );

    $(".mask").removeClass("mask--active");
    $("html").removeClass("noscroll");
  });
});
